import { Component, effect, inject,computed, signal } from '@angular/core';
import { AuthStore } from '../../../../core/authentication/authStore';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { UsertStore } from '../../../../core/context/userStore';
import { TenantService } from '../../../../core/services/tenant-service';
@Component({
  selector: 'app-user-info',
  imports: [    
    NzAvatarModule,
    NzButtonModule,
    NzDropdownModule,
    NzSpinComponent,],
  templateUrl: './user-info.html',
  styleUrl: './user-info.scss',
})
export class UserInfo {

  auth = inject(AuthStore);
  tenantService = inject(TenantService);
  userStore = inject(UsertStore);
  protected readonly userName = this.auth.userName();

  protected readonly availableTenants = computed(() => {
    return this.userStore.userContext()?.avilableTenants ?? [];
  })
  
  protected readonly selectedTenantName = computed(
    () => this.userStore.currentTenant()?.tenantName ?? 'Wybierz tenant'
  );
}
